import { render, staticRenderFns } from "./NoticeMore.vue?vue&type=template&id=42f91218&scoped=true&"
import script from "./NoticeMore.vue?vue&type=script&lang=js&"
export * from "./NoticeMore.vue?vue&type=script&lang=js&"
import style0 from "./NoticeMore.vue?vue&type=style&index=0&id=42f91218&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f91218",
  null
  
)

export default component.exports